// styles.js
export const containerBox = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
};

export const canvasBox = {
    position: "relative"
};

export const canvasStyle = {
    display: "block",
    margin: "0 auto"
};

export const legendBoxContainer = {
    display: "flex",
    flexDirection: "column",
    ml: 4
};

export const getLegendItemStyles = (isHovered, color) => ({
    display: "flex",
    alignItems: "stretch",
    mb: 1,
    fontWeight: isHovered ? "bold" : "normal",
    color: isHovered ? color : "inherit",
    fontSize: isHovered ? "14px" : "12px",
    transform: isHovered ? "scale(1.1)" : "scale(1)",
    transition: "transform 0.2s ease, font-size 0.2s ease",
    "& p": { cursor: "pointer" }
});

export const legendColorBox = {
    width: 20,
    height: 20,
    mr: 1,
    borderRadius: "2px"
};
